export default "__VITE_ASSET__DwkQY6WM__"